import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from "react-router-dom";

import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link as RouterLink } from 'react-router-dom';
import validate from '../../../utils/validate';

import '../styles.scss';

import Copyright from '../Copyright';

import LogoSmall from '../../../../src/assets/images/logo-small.png'
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import DescriptionIcon from '@material-ui/icons/Description';
import Logo from '../../../assets/images/logo_transparent.png'

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ResetPassword = (props: any) => {
  let history = useHistory();
  const [credentials, setCredentials] = useState({ email: '', emailCode: '', password: '', passwordConfirmation: '' })
  const [errors, setErrors] = useState({} as any)
  const { loadingError } = props.auth;
  const { addToast } = props;

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value
    });
  }

  const handleResetPassword = (e: any) => {
    e.preventDefault()
    const validation = validate('login', credentials);
    setErrors({
      ...errors,
      email: validation.email
    })
    props.resetPasswordRequest(credentials.email)
  }

  const submitNewPassword = (e: any) => {
    if (credentials.password === credentials.passwordConfirmation) {
      props.resetPassword({
        email: credentials.email,
        code: credentials.emailCode,
        password: credentials.password
      })
        .then((r: any) => {
          addToast({ type: 'success', message: 'Passwords was successfully reset. You can now login.' })
          setTimeout(() => {
            history.push('/login')
          }, 2000)
        })
        .catch((e: any) => console.error(e))
    } else {
      addToast({ type: 'error', message: 'Passwords do not match' })
    }
  }

  return (
    <div>
      <Grid container component="main" className='root reset-password'>
        <CssBaseline />
        <Grid item xs={12} sm={4} md={4} lg={4} className='image'>
          <a href="https://gutenbergcerts.com" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '30px 30px 0' }}>
            <img style={{ width: '100%' }} src={Logo} alt="gutenberg cert logo" className='CertLogo' />
          </a>
          <div className="cert-steps" style={{ display: 'none' }}>
            <Typography component="h1" variant="h5">
              Create your certificate <br /> in 3 Easy Steps
            </Typography>
            <div className='step'>
              <CloudUploadIcon className='icon red' />
              <Typography component="h2"><b>Step 1: </b> Create/Select Template</Typography>
            </div>
            <div className='step'>
              <MailOutlineIcon className='icon red' />
              <Typography component="h2"><b>Step 2: </b> Upload Recipients</Typography>
            </div>
            <div className='step'>
              <DescriptionIcon className='icon red' />
              <Typography component="h2"><b>Step 3: </b> Send Certificates</Typography>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={8} md={8} lg={8} component={Paper} elevation={6} square
          className='flex right-side'>
          <div className='paper'>
            <section className='topside'>
              <div className='title'>
                <img src={LogoSmall} alt="small logo" className='small-logo hidden' />
                <section>
                  <Typography component="h1" variant="h5">
                    Forgot password
                  </Typography>
                  <Typography component="h2">Remember your password?
                    <Link component={RouterLink} to="/login" className='red bold login'>
                      Log in
                    </Link>
                  </Typography>
                </section>
              </div>
              {loadingError && (
                <Alert className='banner' severity="error">{loadingError && loadingError.message}</Alert>
              )}
              {!props.auth.showConfirmResetPassword && (<form className='form' noValidate>
                <TextField
                  error={errors.email ? true : false}
                  value={credentials.email}
                  onChange={e => handleChange(e)}
                  id={errors.email ? "outlined-error-helper-text" : "email"}
                  label={errors.email ? "Error" : "Email Address"}
                  helperText={errors.email ? `${errors.email}` : ''}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="email"
                  autoComplete="email"
                />
                <div className="actions reset">
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className='submit red-bck white'
                    onClick={(e) => handleResetPassword(e)}
                  >
                    Reset password
                  </Button>
                </div>
              </form>)}
              {props.auth.showConfirmResetPassword && (
                <form className='form' noValidate>
                  <TextField
                    error={errors.emailCode ? true : false}
                    value={credentials.emailCode}
                    onChange={e => handleChange(e)}
                    id={errors.emailCode ? "outlined-error-helper-text" : "emailCode"}
                    label={errors.emailCode ? "Error" : "Confirmation code"}
                    helperText={errors.emailCode ? `${errors.emailCode}` : ''}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="emailCode"
                    autoComplete="emailCode"
                  />
                  <TextField
                    error={errors.password ? true : false}
                    value={credentials.password}
                    onChange={e => handleChange(e)}
                    id={errors.password ? "outlined-error-helper-text" : "password"}
                    label={errors.password ? "Error" : "New Password"}
                    helperText={errors.password ? `${errors.password}` : ''}
                    variant="outlined"
                    margin="normal"
                    required
                    type="password"
                    fullWidth
                    name="password"
                    autoComplete="password"
                  />
                  <TextField
                    error={errors.passwordConfirmation ? true : false}
                    value={credentials.passwordConfirmation}
                    onChange={e => handleChange(e)}
                    id={errors.passwordConfirmation ? "outlined-error-helper-text" : "password"}
                    label={errors.password ? "Error" : "Confirm Password"}
                    helperText={errors.passwordConfirmation ? `${errors.passwordConfirmation}` : ''}
                    variant="outlined"
                    margin="normal"
                    required
                    type="password"
                    fullWidth
                    name="passwordConfirmation"
                    autoComplete="passwordConfirmmation"
                  />
                  <div className="actions reset">
                    <Button
                      type="button"
                      fullWidth
                      variant="contained"
                      color="primary"
                      className='submit red-bck white'
                      onClick={(e) => submitNewPassword(e)}
                    >
                      Reset password
                    </Button>
                  </div>
                </form>
              )}
            </section>
            <Grid container justify="flex-end" className='copyright hidden'>
              <Copyright />
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default ResetPassword;
